import { createFileRoute } from "@tanstack/react-router";
import { NotificationSettings } from "@/app/settings/notification-settings";
import { SettingsNav } from "@/app/shell/settings-nav";
import { useNotificationPrefs } from "@/shared/hooks/use-notification-prefs";

export const Route = createFileRoute("/settings/notifications")({
  component: RouteComponent,
});

function RouteComponent() {
  const { prefs, setKindEnabled } = useNotificationPrefs();

  return (
    <div className="py-12 space-y-6">
      <SettingsNav />
      <div className="max-w-(--form-max-width) mx-auto">
        <NotificationSettings muted={prefs.muted} onToggle={setKindEnabled} />
      </div>
    </div>
  );
}
